export interface News {
  newsTypeID: number;
  highlighted: boolean;
  header: string;
  subject: string;
  body: string;
  dateTime?: string;
  unpublishDate?: string;
}

export interface NewsCreateDTO {
  NewsTypeID: number;
  Header: string;
  Subject: string;
  Body: string;
  Highlighted: boolean;
  PublishDate?: string;
  UnpublishDate?: string;
  ImageFileID?: string;
  Files?: string[];
  DepartmentID?: number;
  ModuleID?: number;
  Departments?: number[];
  DepartmentGroups?: number[];
  Modules?: number[];
  Organizations?: number[];
  OrganizationTypes?: number[];
}

export interface NewsUpdateDTO extends NewsCreateDTO {
  NewsID: number;
}

export interface NewsListItem {
  newsID: number;
  newsTypeID: number;
  departmentID?: number;
  moduleID?: number;
  postedByUserID?: number;
  imageFileID?: string;
  imageFileName?: string;
  imageDisplayFileName?: string;
  imageContentType?: string;
  imageUrl?: string;
  newFiles: string[];
  header: string;
  subject: string;
  body: string;
  highlighted: boolean;
  isRead: boolean;
  publishDate?: string;
  unpublishDate?: string;
}

export interface NewsQuery {
  newsTypeID?: number;
  departmentID?: number;
  ModuleID?: number;
  pageIndex?: number;
  pageSize?: number;
  publishDateStart?: string;
  publishDateEnd?: string;
  unpublishDateStart?: string;
  unpublishDateEnd?: string;
}

export const NewsTypes = [
  {name: 'Generell', id: 1},
  {name: 'Avtal', id: 3},
  {name: 'System', id: 4}
];
